var $cf48bfc540882310$exports = {};
$cf48bfc540882310$exports = {
  "decrease": function decrease(args) {
    return "Diminuir ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "Aumentar ".concat(args.fieldLabel);
  },
  "numberField": "Campo num\xE9rico"
};
export { $cf48bfc540882310$exports as default };